"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipTextField = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const PresentationContext_1 = require("../components/PresentationContext");
const Css_1 = require("../Css");
const utils_1 = require("../utils");
// A TextField styled to look like a Chip
function ChipTextField(props) {
    var _a;
    const { autoFocus, onFocus, onBlur, onEnter, onChange, required, label, value, blurOnEscape = true } = props;
    const { fieldProps } = (0, PresentationContext_1.usePresentationContext)();
    // Use a ref for the value to not cause a re-render when it changes, avoiding cursor position resetting.
    const valueRef = (0, react_1.useRef)(value);
    const tid = (0, utils_1.useTestIds)(props, "chipField");
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const { focusProps } = (0, react_aria_1.useFocus)({
        onFocus: (e) => {
            if (fieldRef.current) {
                // The range/selection logic is to select the text within the field on focus
                const range = document.createRange();
                range.selectNodeContents(fieldRef.current);
                const selection = window.getSelection();
                if (selection) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }
            (0, utils_1.maybeCall)(onFocus);
        },
        onBlur: () => (0, utils_1.maybeCall)(onBlur),
        onFocusChange: setIsFocused,
    });
    const fieldRef = (0, react_1.useRef)(null);
    const typeScale = (_a = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.typeScale) !== null && _a !== void 0 ? _a : "sm";
    (0, react_1.useEffect)(() => {
        var _a;
        autoFocus && ((_a = fieldRef.current) === null || _a === void 0 ? void 0 : _a.focus());
    }, 
    // TODO: validate this eslint-disable. It was automatically ignored as part of https://app.shortcut.com/homebound-team/story/40033/enable-react-hooks-exhaustive-deps-for-react-projects
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // React doesn't like contentEditable because it takes the children of the node out of React's scope. This is fine in this case as it is just a text value and we are managing it.
    return ((0, jsx_runtime_1.jsx)("span", { ref: fieldRef, contentEditable: true, suppressContentEditableWarning: true, "aria-required": required, "aria-label": label, onKeyDown: (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                (0, utils_1.maybeCall)(onEnter);
            }
            else if (blurOnEscape && e.key === "Escape") {
                e.target.blur();
            }
        }, onInput: (e) => {
            var _a, _b, _c;
            const target = e.target;
            if ("inputType" in e.nativeEvent && e.nativeEvent.inputType === "insertFromPaste") {
                // Clean up any formatting from pasted text
                target.innerHTML = (_b = (_a = target.textContent) === null || _a === void 0 ? void 0 : _a.replace(/[A\n\r]/g, " ")) !== null && _b !== void 0 ? _b : "";
            }
            onChange((_c = target.textContent) !== null && _c !== void 0 ? _c : "");
        }, ...focusProps, css: {
            ...Css_1.Css[typeScale].dib.br16.pl1.pxPx(10).pyPx(2).gray900.bgGray300.outline0.mwPx(32).$,
            ...(isFocused ? Css_1.Css.bshFocus.$ : {}),
        }, ...tid, children: valueRef.current }));
}
exports.ChipTextField = ChipTextField;
